import moment from 'moment';

const TimeAgo = ({ date }) => {
  return (
    <span>{moment.utc(date).local().fromNow()}</span>
  );
};
export default TimeAgo;